import VpMenu from './src/menu'
import VpSubmenu from './src/submenu'
import VpMenuItem from './src/menu-item'

VpMenu.MenuItem = VpMenuItem
VpMenu.Submenu = VpSubmenu

export default VpMenu


// WEBPACK FOOTER //
// ./src/components/menu/index.js